// extracted by css-extract-rspack-plugin
export default {"cls1":"ReportList-cls1_PNx","cls2":"ReportList-cls2_gwI ReportList-cls1_PNx"};